import React, { FC } from 'react';
import './switch.css';

interface Props {
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  checked: boolean;
  text?: string;
}

export const Switch: FC<Props> = ({
  onChange,
  checked = false,
  text,
}) => {

  return (
    <label className={`${text ? 'with-text' : ''} toggle`}>
      <input
        type="checkbox"
        className="switch"
        onChange={onChange}
        checked={checked}
      />
      <span className="toggle-content" />
      {text && (<span className="labels">{text}</span>)}
    </label>
  );
};
